import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { MessageService } from '../message.service';
import { Router } from '@angular/router';
import { MetadataService } from '../MetadataService';
import { environment } from '../../environments/environment';
import { KeycloakAuthService } from '../keycloak-auth.service';
declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  isSigned: boolean;
  epimelitirio: string;
  messageModal: string = "Για να έχετε πρόσβαση στην λίστα των υποψηφίων για εργασία πρέπει να έχετε συνδεθεί ως επιχείρηση.";

  constructor(
    public authService: AuthService,
    private router: Router,
    private metadataService: MetadataService,
    public messageService: MessageService,
    private keycloakAuth: KeycloakAuthService
  ) {}

  ngOnInit() {
    this.epimelitirio = environment.environment;
    this.authService.isAuthenticated$.subscribe((res) => {
      this.isSigned = res;

      if (this.isSigned && this.authService.isCompany()) {
        this.authService.getCompanyInfo(this.authService.getCompanyId()).subscribe((data) => {
          this.authService.isValidCompany = data.isValid;
          this.authService.signedName = data.name;
        });
      } else if (this.isSigned && this.authService.isCandidate()) {
        this.authService.getCandidateProfile().subscribe((data) => {
          this.authService.isValidCandidate = data.isValid;
          this.authService.signedName = data.firstName + ' ' + data.lastName;
        });
      }
    });
  }
  login() {
    this.keycloakAuth.login({
      redirectUri: window.location.origin + '/'
    });
  }
  cancel() {
    this.authService.clearSessionUser();
    this.keycloakAuth.logout(window.location.origin + '/', true);
    this.authService.authenticated.next(false);
  }

  jobsList() {
    this.router.navigate(['job-listing']);
  }
  jobListCompany() {
    if (this.authService.isValidCompany) {
      this.router.navigate(['/employers/job-listing', 'all']);
    }

  }
  jobPost() {
    this.router.navigate(['employers/post-a-job']);
  }
  candidatesList() {
    this.router.navigate(['/candidates/list']);
  }
  onUnsignedCandidatesList() {
    this.messageService.setMessageForLoginAndRegisterModal(this.messageModal);
    ($('#MessageModal') as any).modal('show');
  }

  myAccount() {
    if (this.authService.isCompany()) {
      this.authService.getCompanyInfo(this.authService.getCompanyId()).subscribe((data: any) => {
        if (data.isValid === false) {
          this.router.navigate(['employers/complete-profile']);
        } else {
          this.router.navigate(['/employer/profile/', this.authService.getCompanyId()]);
        }
      });
    } else {
      this.authService.getCandidateProfile().subscribe((data: any) => {
        if (data.isValid === false) {
          this.router.navigate(['candidates/complete-profile']);
        } else {
          this.router.navigate(['candidate/profile', this.authService.getCandidateKeycloakId()]);
        }
      });
    }
  }
  myApplies() {
    this.router.navigate(['candidates/applied-job-list']);
  }
  myConfig() {
    this.router.navigate(['candidates/newsletter-preferences']);
  }
}